import { render, staticRenderFns } from "./PromotedView.vue?vue&type=template&id=5274580a&"
import script from "./PromotedView.vue?vue&type=script&lang=js&"
export * from "./PromotedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports